// Vendor imports
const qs = require('qs')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const commonClient = require('client-v2/common/client')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const toastsActions = require('client-v2/common/containers/toasts/actions')
// Entry imports
const configureStore = require('client-v2/logged-out-landing/state/store')
const rootFactory = require('client-v2/logged-out-landing/components/root').factory

commonClient.runAfterPageIsLoaded(() => {

  const { store } = commonClient.render(configureStore, rootFactory)

  commonClient.configureSession(store, {
    pageName: 'LOHP'
  })

  businessEvents.trackSegment('pageview')

  const initialState = store.getState()

  const { pathname, search } = initialState.router.location
  const queryParams = qs.parse(search, { ignoreQueryPrefix: true })
  if (pathname === '/login') {
    // Allow login modal pop-up if specified by pathname
    store.dispatch(authModalActions.showLogin())
  }
  if (queryParams.deleted) {
    const message = 'Account removed successfully'
    store.dispatch(toastsActions.showNotice({ message }))
  }
})
